'use client';

import React, { createContext, useContext } from 'react';
import { useDashboardPolling, DashboardPollingState } from '@/lib/useDashboardPolling';

const DashboardDataContext = createContext<DashboardPollingState | null>(null);

export function DashboardDataProvider({ children }: { children: React.ReactNode }) {
  const polling = useDashboardPolling();
  return (
    <DashboardDataContext.Provider value={polling}>
      {children}
    </DashboardDataContext.Provider>
  );
}

/**
 * Consume the dashboard polling state inside any dashboard panel.
 * `tick` increments every 30 s — use it as a dependency to re-derive
 * computed values from your local mock/data arrays.
 */
export function useDashboardData(): DashboardPollingState {
  const ctx = useContext(DashboardDataContext);
  if (!ctx) {
    throw new Error('useDashboardData must be used inside <DashboardDataProvider>');
  }
  return ctx;
}
